/**
 * Enumeravel usado para restringir o acesso do usuário do sistema EPC a partir da situacao
 */
export enum SituacaoRestrictEnumEPC {
  "Não é possível editar, pois o registro selecionado foi enviado e está aguardando entrega de documentação fisica." = 3,
  "Não é possível editar, pois o registro selecionado já está aguardando análise no CRC - Gestor" = 4,
  "Não é possível editar, pois o registro selecionado já está em análise no CRC - Gestor." = 5,
  "Não é possível editar, pois o registro selecionado já está aguardando julgamento no CRC - Comissão." = 6,
  "Não é possível editar, pois o registro selecionado já está em julgamento no CRC - Comissão." = 7,
  "Não é possível editar, pois o registro selecionado já está aguardando análise no CFC - Gestor." = 8,
  "Não é possível editar, pois o registro selecionado já está em análise no CFC - Gestor." = 9,
  "Não é possível editar, pois o registro selecionado já está aguardando julgamento no CFC - Comissão." = 10,
  "Não é possível editar, pois o registro selecionado já está em julgamento no CFC - Comissão." = 11,
  "Não é possível editar, pois o registro selecionado já está deferido." = 12,
  "Não é possível excluir, pois o registro selecionado já está com processo finalizado." = 15,
  "Não é possível editar, pois o registro selecionado se encontra com status de autorizado." = 18,
}

export enum Situacao2RestrictEnumEPC {
  "Devolvido para adequação" = 13,
  "Aberto para recurso" = 14,
  "Iniciado" = 16,
}
/**
 * Enumeravel usado para restringir o acesso do usuário
 */
export enum AlterSituacaoEnum {
  Ativo = 1,
  Inativo = 2,
}
/**
 * Enumeravel usado para restringir o acesso do usuário do Sistema Registro a partir da situação
 */
export enum SituacaoRestricEnumRegistro {}

/**
 * Enumeravel usado para restringir o acesso do usuário do sistema Registro a partir da situacao junto de um Perfi
 */
export enum SituacaoPerfilRestricEnumRegistro {
  "Não é possível editar um registro com a situação Pré Cadastro - Aguardando Pagamento" = 11,
  "Não é possível editar um registro com a situação Pré Cadastro - Aguardando Documentação Física" = 12,
  "Não é possível editar um registro com a situação cancelado" = 9,
}

/**
 * Enumeravel usado para restringir o acesso do usuário do sistema Registro a partir da situacao junto de um perfil
 */
export enum PerfilSituacaoRestricEnumRegistro {
  "Profissional" = "Profissional",
}

/**
 * Enumeraveis da tabela de domínio situação
 */
export enum SituacaoEnum {
  Inativo = 1,
  Ativo = 2,
  Baixado = 3,
  "Aguardando Homologação" = 4,
  Suspensão = 5,
  "Pré Cadastro" = 6,
  "Em Cadastro" = 7,
  Aprovado = 8,
  Cancelado = 9,
  Cassado = 10,
  "Pré Cadastro - Aguardando Pagamento" = 11,
  "Pré Cadastro - Aguardando Documentação Física" = 12,
  "Aguardando Pagamento" = 13,
  Pendente = 14,
  "Aguardando Analise do CRC" = 15,
  "Aprovado - Aguardando Homologação" = 16,
  "Pendente - Aguardando Complementação" = 17,
  "Aguardando Comparecimento ao CRC" = 18,
  "Não Enviado" = 19,
  Enviado = 20,
  Deferido = 21,
  Indeferido = 22,
  "Aguardando complemento" = 23,
}

export enum SituacaoPessoaFisicaEJuridicaEnum {
  Inativo = 1,
  Ativo = 2,
  Baixado = 3,
  "Aguardando Homologação" = 4,
  Suspensão = 5,
  "Pré Cadastro" = 6,
  "Em Cadastro" = 7,
  Aprovado = 8,
  Cancelado = 9,
  Cassado = 10,
  "Pré Cadastro - Aguardando Pagamento" = 11,
  "Pré Cadastro - Aguardando Documentação Física" = 12,
}

export enum SituacaoCnaipj {
  Pendente = 14,
  Enviado = 20,
  Deferido = 21,
  Indeferido = 22,
  "Aguardando complemento" = 23,
}

export enum SituacaoCnaipjGestor {
  Enviado = 20,
  Deferido = 21,
  Indeferido = 22,
  Baixado = 3,
  Cancelado = 9,
}

/**
 * categorias usadas em Pessoa Física
 */
export enum CategoriaEnum {
  "Não Informado" = 1,
  "Contador" = 2,
  "Técnico em Contabilidade" = 3,
  "Pessoa Física não Profissional" = 4,
}

export enum CategoriaEnumFeminino {
  "Não Informado" = 1,
  "Contadora" = 2,
  "Técnica em Contabilidade" = 3,
  "Pessoa Física não Profissional" = 4,
}

/**
 * situacoes usadas em gerenciar serviço
 */
export enum SituacaoGerenciarServico {
  "Aprovado - Aguardando Homologação" = 1,
  Cancelado = 2,
  "Aguardando Pagamento" = 3,
  "Pendente - Aguardando Complementação" = 4,
  "Aguardando Analise do CRC" = 5,
  "Aguardando Comparecimento ao CRC" = 6,
}
/**
 * Enumeraveis da tabela de domínio assunto
 */
export enum TipoAssunto {
  "Baixa de Registro" = 1,
  "Pedido de Carteira" = 2,
  "Reestabelecimento de Registro" = 3,
  "Alteração de Nacionalidade" = 4,
  "Alteração de Nome" = 5,
  "Alteração de Categoria" = 6,
  "Comunicação" = 7,
  "Transferência" = 8,
  "Alteração Cadastral" = 9,
  "Cancelamento de Registro" = 10,
}

export enum TipoAssuntoPessoaFisica {
  "Baixa de Registro" = 1,
  "Pedido de Carteira" = 2,
  "Reestabelecimento de Registro" = 3,
  "Alteração de Nacionalidade" = 4,
  "Alteração de Nome" = 5,
  "Alteração de Categoria" = 6,
  "Comunicação" = 7,
  "Transferência" = 8,
}

export enum TipoAssuntoPessoaJuridica {
  "Baixa de Registro" = 1,
  "Transferência" = 2,
  "Reestabelecimento de Registro" = 3,
  "Alteração Cadastral" = 4,
  "Cancelamento de Registro" = 5,
}

export enum MotivoPedidoBaixa {
  "Cessacao" = 5,
  "Interrupcao" = 6,
}
/**
 * Ações do Gestor, atualmente está sendo utilizado em gerenciar serviço.
 * Caso modificação verificar o impacto nas telas que á implementa.
 */
export enum AcaoGestorEnum {
  "Aprovar Documentação" = 1,
  "Solicitar Complemento" = 2,
  "Troca de Responsável" = 3,
  "Cancelar Solicitação" = 4,
}

/**
 * Enumeravel usado para restringir o acesso do usuário do sistema EPC a partir do peril
 */
export enum PerfilRestrictEnumEPC {
  "Não é possível editar, para editar a Situação deve ser igual a Iniciada." = "Profissional",
  "" = "Gestor CRC",
}
/**
 * Enumeravel usado para restringir o acesso do usuário do sistema Registro a partir do peril
 */
export enum PerfilRestrictEnumRegistro {}
/**
 * Enumeravel usado para restringir o acesso do usuario do sistema Arrecadação
 */
export enum SituacaoRestrictEnumArrecadacao {
  "Inativo" = 1,
  "Ativo" = 2,
  "Em Análise" = 3,
  "Autorizado" = 4,
}
/**
 * Enumeration padrao, usada somente para evitar erros ao aplicar alguma variavel sem enum.
 */
export enum EnumPadrao {}
/**
 * Tipo de Vinculo Do Sócio - SISTEMA REGISTRO
 */
export enum TipoVinculoEnumRegistro {
  "Sócio" = 1,
  "Funcionário" = 2,
  "Contratado" = 3,
  "Filial" = 4,
  "Titular" = 5,
  "Matriz" = 6,
}

export enum TipoVinculo {
  "Sócio" = 1,
  "Funcionário" = 2,
  "Contratado" = 3,
  "Filial" = 4,
  "Titular" = 5,
  "Matriz" = 6,
  "Responsável Técnico" = 7,
  "Sócio e Responsável Técnico" = 8,
}

export enum TipoVinculoCnaipj {
  "Sócio" = 1,
  "Responsável Técnico" = 7,
  "Sócio e Responsável Técnico" = 8,
}

/**
 * Enum padrão para sim e não
 */
export enum CondicaoSimNaoPadrao {
  "Sim" = 1,
  "Não" = 2,
}

export enum Acao {
  New = 1,
  Update = 2,
  Delete = 3,
  None = 4,
}

export enum AcaoHistorico {
  "Cadastro da Solicitação" = 1,
  "Envio da Solicitação" = 2,
  "Baixa de Registro" = 3,
  "Deferimento" = 4,
  "Indeferimento" = 5,
  "Alteração da composição societária" = 6,
  "Alteração de informações" = 7,
  "Ativação de Registro" = 8,
  "Solicitação de Complemento" = 9,
  "Assinatura da Declaração de Conformidade" = 10,
  "Cancelamento" = 11,
  "Restabelecimento de Registro" = 12,
}

export enum Situacoes {
  "Pré Cadastro" = 1,
  "Cadastrado" = 2,
}

export enum TipoTelefone {
  Celular = 1,
  Residencial = 2,
  Comercial = 3,
}

export enum TipoTitulo {
  "Graduação" = 1,
  "Pós-Graduação" = 2,
  "Mestrado" = 3,
  "Doutorado" = 4,
  "Pós-Doutorado" = 5,
}

export enum Sexo {
  "Masculino" = 1,
  "Feminino" = 2,
  "Não Informado" = 3,
}

export enum TipoEndereco {
  Residencial = 1,
  Comercial = 2,
}

export enum EstadoCivil {
  "Solteiro(a)" = 1,
  "Casado(a)" = 2,
  "Viúvo(a)" = 3,
  "Divorciado(a)" = 4,
  "Separado(a)" = 5,
}

export enum EstadoCivilPessoaFisica {
  "Solteiro" = 1,
  "Casado" = 2,
  "Viúvo" = 3,
  "Divorciado" = 4,
  "Separado" = 5,
}

export enum TipoVisto {
  "Trânsito " = 1,
  "Turista" = 2,
  "Temporário" = 3,
  "Permanente" = 4,
  "Cortesia" = 5,
  "Oficial" = 6,
  "Diplomático" = 7,
}

export enum TipoVistoPessoaFisica {
  "Trânsito " = 1,
  "Turista" = 2,
  "Temporário" = 3,
  "Permanente" = 4,
}

export enum TipoOrganizacao {
  Matriz = 1,
  Filial = 2,
}

export enum TipoArquivo {
  Anexo = 1,
  Remessa = 2,
  Alvara = 3,
  Certidao = 4,
  ComprovanteComunicacao = 5,
  CertidaoCNAIPJ = 6,
  AutenticacaoCNAIPJ = 7,
}

export enum EtapasPreCadastroPf {
  DadosPessoais = 1,
  Perfil = 2,
  Endereco = 3,
  Telefone = 4,
  Documentos = 5,
  Escolaridade = 6,
  AnexarDocumentos = 7,
  Resumo = 8,
}

export enum EtapasPrecadastro {
  DadosPessoais = 1,
  Perfil = 2,
  Endereco = 3,
  Telefone = 4,
  Documentos = 5,
  Escolaridade = 6,
  AnexarDocumentos = 7,
  DadosEmpresa = 8,
  ComposicaoSocietaria = 9,
  Resumo = 10,
}

export enum EtapasPreCadastroPj {
  DadosEmpresa = 1,
  ComposicaoSocietaria = 2,
  Endereco = 3,
  Telefone = 4,
  AnexarDocumentos = 5,
  Resumo = 6,
}

export enum TipoDocumento {
  "Foto" = 1,
  "Identidade" = 2,
  "Titulo de Eleitor" = 3,
  "Certidão de Reservista" = 4,
  "CPF" = 5,
  "Certidão de casamento, divórcio ou separação" = 6,
  "Diploma" = 7,
  "Comprovante de Endereço" = 8,
  "Exame de Suficiência" = 9,
  "Requerimento de Nome Social" = 10,
  "Ato Constitutivo ou Contrato Social devidamente registrado em órgão competente" = 11,
  "Outros Documentos" = 12,
  "Cópia autenticada da alteração contratual registrada na Junta Comercial ou em Cartório" = 13,
  "Cópia do CNPJ" = 14,
  "Certidão de Regularidade no respectivo órgão de fiscalização para os sócios que não são profissionais da Contabilidade" = 15,
  "Certificado de Nacionalidade ou certidão de nascimento averbada" = 16,
  "Requerimento" = 17,
  "2 fotos 3X4 coloridas de fundo branco" = 18,
  "Certidão de Óbito ou documento equivalente" = 19,
  "Distrato Social / Comprovante de Extinção" = 20,
  "Comprovante de interrupção das atividades (Alteração Contratual paralizando as atividades ou alteração mudando o objetivo social e outros)" = 21,
  "Requerimento de Carteira" = 22,
  "Assinatura" = 23,
  "Impressão Digital" = 24,
  "Comprovante de Pagamento" = 25,
  "CNPJ" = 26,
  "Comprovação da responsabilidade técnica" = 27,
  "Cópias de documento de identidade oficial do sócio não contabilista" = 28,
  "Comprovante de residência dos sócios não contabilistas" = 29,
  "Comprovante de registro em conselho de profissão regulamentada dos sócios não contadores" = 30,
  "Certidão de Casamento, Certidão de Divórcio ou Certidão de Nascimento" = 31,
  "Documento de Identificação oficial" = 32,
  "Carteira de identidade Profissional" = 33,
  "Certidão de Casamento, Certidão de Divórcio, Certidão de Nascimento documento que originou alteração de nacionalidade" = 34,
  "Requerimento Assinado" = 35,
  "Ato constituitivo, original e cópia, bem como suas alterações, ou contrato consolidado, devidamente registrados no órgão competente." = 36,
  "Comprovação de registro no CRC de origem" = 37,
  "Inscrição no Cadastro Nacional de Pessoa Jurídica (CNPJ)" = 38,
  "Documento de Identificação oficial dos sócios que não são profissionais da contabilidade" = 39,
  "Comprovante de residência dos sócios que não são profissionais da contabilidade" = 40,
  "Comprovação de registro em conselho de profissão regulamentada dos sócios que não são profissionais da contabilidade" = 41,
  "Documento de Identificação dos sócios que não são profissionais da contabilidade" = 42,
  "Comprovante de responsabilidade técnica" = 43,
  "Contrato Social" = 44,
  "Comprovante de Inscrição no orgão competente" = 45,
  "Distrato Social ou requerimento de cancelamento devidamente registrado no órgão competente" = 46,
}

export enum TipoOrgao {
  "Junta" = 1,
  "Cartório" = 2,
}

export enum NaturezaJuridica {
  "Sociedade empresaria limitada" = 1,
  "Eireli" = 2,
  "Empresario individual" = 3,
}

export enum TipoRegistro {
  "Definitivo" = 1,
}

/**
 * Mensagens padrão do sistema
 */
export enum MensagensPadrao {
  "Sucesso ao salvar registro." = 1,
  "Sucesso ao atualizar registro." = 2,
  "Erro ao tentar salvar registro, tente novamente mais tarde." = 3,
  "Erro ao tentar atualizar registro, tente novamente mais tarde." = 4,
  "A lista deve conter ao menos um registro." = 5,
  "A lista deve conter ao menos um registro marcado como principal para ser salva." = 6,
  "Já existe um item na lista com esses dados." = 7,
  "Registro autorizado com sucesso." = 8,
  "Houve um erro ao autorizar o registro." = 9,
  "Não é possível autorizar novamente um registro que já foi autorizado." = 10,
  "Opção não existe." = 11,
  "Registro foi enviado com sucesso." = 12,
  "Houve um erro ao enviar o registro." = 13,
  "Não é possível enviar este cadastro, o registro já foi enviado." = 14,
  "Não é possível enviar este cadastro, o profissional precisa ter a Situação Iniciada e Status Em Análise." = 15,
  "Nenhum registro encontrado." = 16,
  "Registro excluído com sucesso." = 17,
  "Houve um erro ao excluir o registro." = 18,
  "É necessário que cada lista apresentada possua ao menos um dado para poder ser persistida." = 19,
  "Já existe um registro principal nessa lista." = 20,
  "É necessário ao menos um registro principal." = 21,
  "Erro ao obter registro." = 22,
  "Erro ao tentar atualizar registro." = 23,
  "É necessario marcar a declaração de que os dados inseridos estão corretos para prosseguir." = 24,
  "É necessario cadastrar suas informações em todas as demais etapas para marcar o Termo de Aceite." = 25,
  "Existe um registro principal na lista." = 26,
  "<br>Anexar, de forma legível, os documentos originais que certifiquem a autenticidade das informações prestadas, acelera a obtenção do registro." = 27,
  "Data fim do Mandato não pode ser menor que a data de início do Mandato" = 28,
  "Serviço não possui taxas a serem pagas" = 29,
  "Sucesso ao atribuir responsável ao(s) Serviços(s)." = 30,
  "É necessário anexar todos os documentos obrigatórios." = 31,
}
/**
 * Cabeçalho padrão para apresentação de mensagens no sistema
 */
export enum CabecalhoMensagens {
  "Mensagem de Confirmação" = 1,
  "Mensagem de Sucesso" = 2,
  "Mensagem de Aviso" = 3,
  "Mensagem de Erro" = 4,
  "Mensagem Informativa" = 5,
}
/**
 * Tipos de mensagem a serem exibidas.
 */
export enum TipoMensagem {
  "success" = 1,
  "info" = 2,
  "warn" = 3,
  "error" = 4,
}

export enum Profissao {
  "Outros" = 105,
  "OutrosHomolog" = 1003,
}

export enum TipoCarteira {
  Física = 1,
  Digital = 2,
}

export enum Lotacao {
  CFC = 1,
  CRC_AC = 2,
  CRC_AL = 3,
  CRC_AM = 4,
  CRC_AP = 5,
  CRC_BA = 6,
  CRC_CE = 7,
  CRC_DF = 8,
  CRC_ES = 9,
  CRC_GO = 10,
  CRC_MA = 11,
  CRC_MG = 12,
  CRC_MS = 13,
  CRC_MT = 14,
  CRC_PA = 15,
  CRC_PB = 16,
  CRC_PE = 17,
  CRC_PI = 18,
  CRC_PR = 19,
  CRC_RJ = 20,
  CRC_RN = 21,
  CRC_RO = 22,
  CRC_RR = 23,
  CRC_RS = 24,
  CRC_SC = 25,
  CRC_SE = 26,
  CRC_SP = 27,
  CRC_TO = 28,
}



// WEBPACK FOOTER //
// ./src/app/base/use-system/enums/Enumarations.ts